export default "__VITE_ASSET__kDfxVgGl__"